<template>
  <div class="select-menu">
    <div class="select-menu-input">
      <el-select v-model="menu" filterable placeholder="搜索指定模块路由" @change="changeMenu">
        <el-option-group
          v-for="group in menuOptions"
          :key="group.title"
          :label="group.title"
        >
          <el-option
            v-for="(item,index) in group.children"
            :key="index"
            :label="`${item.title}-${item.modulesTitle}-${group.title}`"
            :value="item.path"
          >
            <span style="padding-left:5px" :title="`${item.title}-${item.modulesTitle}-${group.title}`">
              {{ item.title }}
              <span style="float: right; color: #8492a6; font-size: 12px">{{ item.modulesTitle }}</span>
            </span>
          </el-option>
        </el-option-group>
      </el-select>
      <i class="el-icon-search el-icon-select-query" style="font-size:15px" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menu: '',
      menuOptions: []
    }
  },
  watch: {
    $route(value) {
      if (value.path !== this.menu) {
        // 非选中的路由，清空
        this.menu = ''
      }
    }
  },
  created() {
    this.getMenuList()
  },
  methods: {
    changeMenu() {
      this.$router.push(this.menu)
    },
    getMenuList() {
      this.menuOptions = []
      const menuOptions = []
      this.$global.modules.forEach(element => {
        menuOptions.push({
          title: element.name, modules: element.value, children: []
        })
      })
      menuOptions.push({ title: '管理员', modules: '*', children: [] })
      const route = this.$store.getters.permission_routes
      route.forEach(element => {
        if (!element.hidden && element.children && element.meta) {
          const findIndex = menuOptions.findIndex(_ => {
            return element.type === _.modules
          })
          element.children.forEach(item => {
            if (item.meta && !item.hidden) {
              let path = item.meta.permission_uri
              if (menuOptions[findIndex].modules === '*') {
                // 管理员模块
                path = element.path + '/' + item.path
              }
              menuOptions[findIndex].children.push({
                path: path,
                title: item.meta.title,
                modulesTitle: element.meta.title
              })
            }
          })
        }
      })
      menuOptions.forEach(element => {
        if (element.children.length > 0) {
          this.menuOptions.push(element)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.select-menu{
  float: left;
  line-height: 40px;
  height: 48px;
  .select-menu-input{
    position: relative;
    top: 15%;
    margin-right: 10px;
  }
  >>> .el-input__inner{
    border-radius: 20px
  }
  >>> .el-input__suffix{
    display: none;
  }
  .el-icon-select-query{
    position: absolute;
    right: 10px;
    top: 10px;
    color: #C0C4CC;
  }
}

@media  (max-height: 1000px) and (max-width: 1000px) {
  // 横屏时 时间控件留点位置可以触碰关闭
  .select-menu{
    display: none;
  }
}
@media  (max-width: 450px) {
  // 竖屏时 时间控件超出位置问题
  .select-menu{
    display: none;
  }
}
</style>
